var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sidebar', _vm.fold ? 'sidebar-fold' : undefined]},[_c('div',{class:[`sidebar-logo-block-${_vm.edition}`]},[_c('span',{attrs:{"font":""}},[_vm._v("USF3"+_vm._s(_vm.$t('language.5o6u1gml4ik9')))])]),_c('el-scrollbar',[_c('side-menu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }